import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"clipboard, copy, list"} maskId="square-filled-radius-0-stroke-1-IconClipboard"><path fillRule="evenodd" clipRule="evenodd" d="M16 2H8V4H4V22H20V4H16V2ZM15 3H9V6H15V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconClipboard;
